module.exports = __webpack_public_path__ + "static/creative-market-1aa2af7c12ffebbf838ded9fa8c5bf2b.svg";